import React, { useCallback, useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { Container, Hero, Event } from './styles';

import hero from '~/assets/banners/hero-home-new.png';
import { useAuth } from '~/hooks/Auth';
import api from '~/services/api';

interface ITicketCheckin {
  event_id: number;
  total: number;
  read: number;
  unread: number;
}

const Dashboard: React.FC = () => {
  const { event, signOut } = useAuth();
  const [ticketCheckin, setTicketCheckin] = useState<ITicketCheckin>(
    {} as ITicketCheckin
  );

  const handleLoadTickets = useCallback(async () => {
    const response = await api.get<ITicketCheckin>(
      `/tickets/checkin/${event.id}`
    );
    setTicketCheckin(response.data);
  }, [event.id]);

  useEffect(() => {
    handleLoadTickets();
  }, [handleLoadTickets]);

  return (
    <Container className="position-relative">
      <Hero>
        <div className="container">
          <div className="row">
            <div className="col-12 py-5 px-3">
              <img src={hero} alt="Banner hero" className="w-100" />
            </div>
          </div>
        </div>
      </Hero>
      <Event className="pb-4">
        <div className="container h-100">
          <div className="h-100 row align-content-between">
            <div className="col-12 px-3">
              <h3 className="h2 mb-3">{event.name}</h3>
              {event.hour &&
                event.end_hour &&
                event.hour !== '00:00:00' &&
                event.end_hour !== '00:00:00' && (
                  <p>
                    Início: <b className="mx-3">{event.hour}</b> Fim:{' '}
                    <b className="mx-3">{event.end_hour}</b>
                  </p>
                )}
              <p>
                <span>Total de ingressos:</span>{' '}
                <b>{ticketCheckin.total?.toString().padStart(2, '0')}</b>
              </p>
              <p>
                <span>Ingressos validados:</span>{' '}
                <b className="text-success">
                  {ticketCheckin.read?.toString().padStart(2, '0')}
                </b>
                <small>
                  {' '}
                  {Math.round(
                    (ticketCheckin.read / ticketCheckin.total) * 100
                  ) || 0}
                  %
                </small>
              </p>
              <p>
                <span>Ingressos a validar:</span>{' '}
                <b className="text-danger">
                  {ticketCheckin.unread?.toString().padStart(2, '0')}
                </b>{' '}
                <small>
                  {Math.round(
                    (ticketCheckin.unread / ticketCheckin.total) * 100
                  ) || 0}
                  %
                </small>
              </p>
            </div>
            <div className="col-12 p-3">
              <Link
                to={`${process.env.PUBLIC_URL}/qr-code`}
                className="btn btn-primary w-100 py-3 big"
              >
                Escanear QR Code
              </Link>
              <button
                type="submit"
                className="btn btn-signout w-100 py-3 big mt-5"
                onClick={signOut}
              >
                Sair
              </button>
            </div>
          </div>
        </div>
      </Event>
    </Container>
  );
};

export default Dashboard;
